import { connect } from 'react-redux';
import {actions} from '../../../../../redux/modules/Establecimientos/establecimientos';
import EstablecimientoGrid from './EstablecimientosGrid';

const mstp = state => {
    return {
        ...state.establecimientos, 
        permisos: state.login.me.permisos
    }
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(EstablecimientoGrid)
